import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const projectFieldFragment = gql`
  fragment projectFieldItem on PlannerField {
    id
    uid
    value
    pseudoFieldUid
  }
`;

// TODO :  discuss and make this fragment approach better
// if we can compleltely remove this
export const projectDetailFragment = gql`
  fragment projectDetailItem on Project {
    id
    projectGroup {
      id
      type
    }
    supervisors {
      ...userNameFields
      profileImage
      isArchived
      isArchivedV2(filters: { academicYearId: $academicYearId })
    }
    studentCollaborators {
      id
      student {
        ...userNameFields
        profileImage
      }
      ibPYPElementRatings {
        id
        ibPYPElementId
        ibPYPElementType
        value
        academicCriteriaSet {
          id
          label
          criteriaType
        }
        academicCriteriaValue {
          id
          label
          abbreviation
        }
      }
      toolResponses(userFilter: ALL) {
        id
        rowId
        columnId
        subjectiveResponse
        creatorType
      }
      assessmentRemarks {
        id
        message
        isLocked
        lockingState {
          state
        }
      }
      fields(filters: $projectFieldFilters) {
        ...projectFieldItem
      }
    }
    status
    reportStatus
    assessmentRemarks {
      id
      message
      isLocked
      lockingState {
        state
      }
    }
    fields(filters: $projectFieldFilters) {
      ...projectFieldItem
    }
  }
  ${projectFieldFragment}
  ${userNameFragment}
`;
